import lodash from 'lodash';

const getUserLevelsSupportedList = (levels: string) => {
	const userLevels = levels
		.split(',')
		.map((level: any) => level.trim())
		.filter((level: any) => level !== '');
	return userLevels.map((level: any) => Number(level));
};

export const hydrateFormData = (data: any) => {
	const { prizeDistribution, maxWinners, userLevelsSupported } = data;
	const prizeGroups: any[] = [];
	Object.entries(prizeDistribution[maxWinners]).forEach((prizeGroup: any) => {
		prizeGroups.push({ rank: Number(prizeGroup[0]), prize: Number(prizeGroup[1]) });
	});
	const hydratedData = {
		...data,
		prizeGroups
	};
	hydratedData.mttSchemaId = data.id;
	if (lodash.has(hydratedData, '_id')) delete hydratedData._id;
	if (lodash.has(hydratedData, 'id')) delete hydratedData.id;
	if (lodash.has(hydratedData, 'index')) delete hydratedData.index;
	hydratedData.userLevelsSupported = !lodash.isNil(userLevelsSupported) ? String(userLevelsSupported) : '';
	if (hydratedData.coinDistribution && hydratedData.coinDistribution.length > 0) {
		hydratedData.coinDistribution = hydratedData.coinDistribution.map((item: any) => {
			if (item.label && !item.rank) {
				const rankMatch = item.label.match(/Rank\s+(\d+)/i);
				return {
					rank: rankMatch ? Number(rankMatch[1]) : undefined,
					zcoins: item.zcoins
				};
			}
			return item;
		});
	}
	return hydratedData;
};

export const dehydrateFormData = (data: any) => {
	const { userLevelsSupported: levels } = data;
	const maxWinners = Number(data.maxWinners);
	// Use the distribution arrays as they are from the form
	const completePrizeGroups = data.prizeGroups || [];
	const completeCoinDistribution = data.coinDistribution || [];

	const newData: any = {
		entryFee: Number(data.entryFee),
		numberOfRounds: Number(data.numberOfRounds),
		playersPerTable: Number(data.playersPerTable),
		maxWinners,
		winnersPerTable: Number(data.winnersPerTable),
		totalWinners: maxWinners,
		userLevelsSupported: getUserLevelsSupportedList(levels),
		instruction: data.instruction ? data.instruction : '',
		segmentsList: data.segmentsList ? data.segmentsList : '',
		totalDistributions: completePrizeGroups?.length,
		tournamentDisplayTime: data.tournamentDisplayTime,
		tournamentRegistrationStartTime: data.tournamentRegistrationStartTime,
		tournamentStartTime: data.tournamentStartTime,
		isSpecial: data.isSpecial,
		isActive: data.isActive,
		isQuickTournament: data.isQuickTournament,
		prizeGroups: completePrizeGroups,
		rakebackPoints: !lodash.isEmpty(data.rakebackPoints) ? parseFloat(data.rakebackPoints) : undefined,
		enableMLMatchMaking: data.enableMLMatchMaking,
		coinEntryFee: !lodash.isNil(data.coinEntryFee) ? Number(data.coinEntryFee) : undefined,
		coinDistribution:
			completeCoinDistribution && completeCoinDistribution.length > 0
				? completeCoinDistribution.map((item: any) => ({
						label: `Rank ${item.rank}`,
						zcoins: Number(item.zcoins)
				  }))
				: undefined
	};
	if (!lodash.isNil(data.stt) && !lodash.isEmpty(data.stt)) newData.stt = Number(data.stt);
	if (!lodash.isNil(data.timeLimitInSecs) && !lodash.isEmpty(data.timeLimitInSecs))
		newData.timeLimitInSecs = Number(data.timeLimitInSecs);
	if (!lodash.isNil(data.mttSchemaId)) newData.mttSchemaId = data.mttSchemaId;
	newData.tournamentComingSoonTime = data.tournamentComingSoonTime ? data.tournamentComingSoonTime : null;
	return newData;
};
